import gql from "graphql-tag";

export default gql`
	query SubscriptionWithPaymentMethod($subscriptionID: Int!) {
		getSubscriptionByID(subscriptionID: $subscriptionID) {
			subscriptionID
			dateCreated
			expirationDate
			status
			archiveBit
			allowedActivations
			isTrial
			isAutoBillingEnabled
			customer {
				email
			}
			serialNumbers {
				code
				licenseName
				serialNumber
				usedActivations
				activations {
					id
				}
			}
			paymentInfo {
				firstName
				lastName
				cardType
				lastFour
				expYear
				expMonth
				cardType
			}
			billingName
			billingEmail
			billingCompany
			billingDepartment
			billingAddress1
			billingAddress2
			billingCity
			billingState
			billingZipCode
			billingCountryID
			billingCountry {
				name
			}
			paymentMethod {
				address1
				address2
				address3
				phone
				city
				state
				email
				zipCode
				countryID
				country {
					name
					isoAlpha2
				}
				company
				firstName
				lastName
			}
			billingPhoneNumber
			plan {
				name
				planCode
			}
			renewalPlan {
				name
			}
			orders {
				orderNumber
				invoiceNumber
				status
				totalAmount
				orderDate
				createdBy
				orderCategoryID
			}
			allowedOperations {
				addons
				viewInvoice
			}
		}
	}
`;

export const readSubscriptionData = ({ data }) => data && data.getSubscriptionByID;
